// extracted by mini-css-extract-plugin
export default {"card":"SetPassword_card__eSB59","submitButton":"SetPassword_submitButton__Cen2D"};